import * as React from 'react';
import { Link } from 'react-router-dom';

export const Hampton = () => {
    return (
        <div className="container">
            <h2>35th Annual - Hampton Beach Regatta</h2>
            <h3>JUNE 20 & 21</h3>
            <h3>Hampton Beach, NH</h3>
            <h3>All Catamarans Welcome!</h3>

            <div class="row mt-5">
                <div class="col-3">
                    <div class="thumbnail">
                        {/* <img title="DSC01082" src="http://dennishelmar.com/cranne/assets/images/DSC01082.JPG" alt="DSC01082" /> */}
                        <img title="CRANNE" alt="CRANNE" src="/images/logo.png" />
                    </div>
                </div>
                <div class="col-7">
                    <p>Join us this June in New Hampshire to sail/race at Beautiful and Exciting Hampton Beach.</p>
                    <p>Dust off your boat and bring all your Friends</p>
                    <p class="text-info">
                        Questions?
                        <a href="mailto://hampton.beach.regatta@comcast.net">  Contact the organizers</a>
                    </p>
                    <a class="btn btn-success" href="/library/HamptonBeachNOR 2015.pdf">Download The Notice of Race</a>
                </div>
                <div class="col-2">
                    <div class="thumbnail">
                        <img title="NENSA" alt="NENSA" src="/images/NENSALogo.PNG" />
                    </div>
                </div>
            </div>

            <div class="row mb-2 mt-5">
                <div class="col-md-12">
                    <div class="p-3 bg-info bg-opacity-10 border border-info rounded-top">
                        Sponsored by</div>
                    <div class="bg-opacity-10 border border-info rounded-bottom">
                        <div class="row row-col-2">
                            <div class="col">
                                {/* <!--img alt="100%x200" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9InllcyI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTkyIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDE5MiAyMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPjxkZWZzLz48cmVjdCB3aWR0aD0iMTkyIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0VFRUVFRSIvPjxnPjx0ZXh0IHg9IjcxLjUiIHk9IjEwMCIgc3R5bGU9ImZpbGw6I0FBQUFBQTtmb250LXdlaWdodDpib2xkO2ZvbnQtZmFtaWx5OkFyaWFsLCBIZWx2ZXRpY2EsIE9wZW4gU2Fucywgc2Fucy1zZXJpZiwgbW9ub3NwYWNlO2ZvbnQtc2l6ZToxMHB0O2RvbWluYW50LWJhc2VsaW5lOmNlbnRyYWwiPjE5MngyMDA8L3RleHQ+PC9nPjwvc3ZnPg==" data-holder-rendered="true" style="height: 200px; width: 100%; display: block;"--> */}
                                <img alt="Hampton Chamer of Commerce" src="/images/sponsors/HACC PROUDLY LOGO-360.jpg" />
                            </div>
                            <div class="col">
                                <h3>Visit The Web Site</h3>
                                <a href="http://hamptonchamber.com/" target="_blank" rel="noreferrer">http://hamptonchamber.com/</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-5">
                {/* <div class="col-xs-2 col-md-2">
                    <div class="thumbnail">
                        <img src="http://dennishelmar.com/cranne/assets/images/autogen/a_DSC01100.gif" alt="Hampton 2011" />
                    </div>
                    <div class="thumbnail">
                        <img src="http://dennishelmar.com/cranne/assets/images/autogen/a_Hampton_2011_060.jpg" alt="Hampton 2011" />
                    </div>
                    <div class="thumbnail">
                        <img src="http://dennishelmar.com/cranne/assets/images/autogen/a_Hampton_2011_139.jpg" alt="Hampton 2011" />
                    </div>
                    <div class="thumbnail">
                        <img src="http://dennishelmar.com/cranne/assets/images/autogen/a_tmp944F.jpg" alt="Hampton 2011" />
                    </div>
                    <div class="thumbnail">
                        <img src="http://dennishelmar.com/cranne/assets/images/autogen/a_Hampton_Beach_Ragatta_2011_392.jpg" alt="Hampton 2011" />
                    </div>
                    <div class="thumbnail">
                        <img src="http://dennishelmar.com/cranne/assets/images/autogen/a_Hampton_2011_103.jpg" alt="Hampton 2011" />
                    </div>
                </div> */}

                <div class="col-12" role="main">
                    <div class="row">
                        <div class="col-md-12">
                            <Link className='btn btn-outline-secondary' to="/hampton/news">In The News</Link>
                            <hr />
                            <h3>Directions</h3>
                            <p>
                                Take I-95 to Exit 2
                                Rte. 101 East to Ocean (Rt. 1A). Regatta Site is north end of the main Beach at the Marine Memorial Statue. Pull up by the ramp and we will take your trailer onto the beach.
                            </p>
                            <p>New Bathrooms w/ outside showers.</p>
                            <p class="small text-info">Note that traffic at Hampton Beach can be intense. Save the stress for the start and get there early.  Please arrive by 8:00 am so we can help you get
                                on to the beach.</p>
                            <hr />
                            <h3>Schedule</h3>
                            <table class="table">
                                <tr>
                                    <td class="lead">Friday</td>
                                    <td>6:00pm - 8:00pm Boat Drop <em>(Please No Earlier)</em></td>
                                </tr>
                                <tr>
                                    <td class="lead">Saturday</td>
                                    <td>
                                        Boat Drop 7:30am – 9:30am<br />
                                        Registration 8:00 - 9:30 am<br />
                                        <strong>Skippers Meeting 9:00 am</strong><br />
                                        First Flag 11:00am
                                    </td>
                                </tr>
                                <tr>
                                    <td class="lead">Sunday</td>
                                    <td>
                                        <strong>Skippers Meeting 9:00 am</strong><br />
                                        First Flag 10:00am
                                    </td>
                                </tr>
                            </table>
                            <h3>Fees</h3>
                            <p><span class="fw-bold">Single Hand</span>&nbsp;&nbsp;$40</p>
                            <p><span class="fw-bold">Youth (under 18)</span>&nbsp;&nbsp;Free</p>
                            <p><span class="fw-bold">All Others</span>&nbsp;&nbsp;$50</p>
                            <p class="text-info">( Paid Cranne/ Nensa members receive $5 discount)</p>
                            <hr />
                            <h3>Contact</h3>
                            <dl class="dl-horizontal">
                                <dt>Scott Malcolm</dt><dd>603-502-7451 </dd>
                            </dl>
                            <a href="mailto:Hampton.beach.regatta@comcast.net">Hampton.beach.regatta@comcast.net</a>
                            <hr />
                            <article>
                                <h3>Accommodations</h3>
                                <table class="table table-borderless">
                                    <thead>
                                        <th>
                                            On the beach $$$$$
                                        </th>
                                    </thead>
                                    {/* <!--<dt>Beach View Inn</dt><dd>603-926-2520 </dd>--> */}
                                    <tr><td >Ships Inn</td><td>(603) 926-4600</td></tr>
                                    <tr><td >Grayhurst</td><td>(603) 926-2584</td></tr>
                                    <tr><td >Hampton House</td><td> (603) 926-1033</td></tr>
                                    <tr><td >Ashworth by the Sea</td><td> (603) 926-6762</td></tr>
                                    <tr><td >Grand View</td><td> (603) 926-5171</td></tr>
                                    <tr><td >Agean Motel</td><td>(603) 926-4600</td></tr>

                                    <tr>
                                        <th>Off of the beach $$</th>
                                    </tr>
                                    <tr><td>Hampton Village Resort</td><td> (800)-292-9990</td></tr>
                                    <tr><td>Lamie's Inn</td><td> (603) 926-0330</td></tr>
                                    <tr><td>Hampton Falls Inn</td><td> (800) 356-1729</td></tr>
                                    <tr><td>Hampshire Inn Seabrook, NH</td><td>(603) 474-5700</td></tr>
                                </table>
                            </article>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <p>
                                <em>This Event is officially sanctioned by the New England Catamaran Sailing Association.</em>
                            </p>
                            <p>
                                <em>
                                    All activities are staffed by Volunteers.
                                </em>
                            </p>
                            <p><em>Hosted by State of NH Department of Resources and Economic Development, Division of Parks and Recreation</em>
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-2 col-md-2">
                            <img class="img-thumbnail img-fluid" alt="NH Dept. Resources and Economic Development, Div. Parks and Rec." src="/images/sponsors/parks-logo-cmyk-1in.jpg" />
                        </div>
                        <p>
                            <em>Hosted by State of NH Department of Resources and Economic Development, Division of Parks and Recreation</em>
                        </p>
                    </div>

                </div>
                <div class="col-md-3" role="complementary">
                    {/* <!--<div class="panel panel-info">
                        <div class="panel-heading">Beachview Inn</div>
                        <div class="panel-body">
                            <div class="thumbnail">
                                <a href="http://beachviewinn.com" target="_blank" rel="noreferrer">
                                    <img alt="Beach View Inn" src="/images/sponsors/BeachViewInnAd.png" />
                                </a>
                            </div>
                        </div>
                    </div>--> */}
                    <div class="p-3 bg-info bg-opacity-10 border border-info rounded-top">
                        New England Catamarans
                    </div>
                    <div class="p-3 border rounded-bottom">
                        <img class="img-thumbnamil img-fluid" alt="New England Catamarans" src="/images/sponsors/NewEnglandCats.png" />
                        <a href="http://www.new-england-catamarans.com" target="_blank" rel="noreferrer">www.new-england-catamarans.com </a>
                    </div>

                    <div class="p-3 my-4 bg-info bg-opacity-10 border border-info rounded-top">
                        Weather Routing Inc. (WRI)</div>
                    <div class="p-3 border rounded-bottom">
                        <a class="img-thumbnamil img-fluid" href="/images/sponsors/WRI Announcement for Hampton Beach Catamaran Regatta.pdf" target="_blank" rel="noreferrer">
                            <img alt="Weather Routing Inc. (WRI)" src="/images/sponsors/WRILogo.png" />
                        </a>
                        <p>
                            WRI is pleased to Provide <a href="http://www.wriwx.com/clientproduct.php?id=6142" target="_blank" rel="noreferrer"> weather forecasts</a> for hampton beach catamaran regatta.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hampton;
